import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum BureauSelfieServiceEnum {
  generateNewLink = "/generate-new-link/",
  validateResendSelfie = "/validate-resend/",
  getSelfieImage = "/selfie-image/"
}

export default class BureauSelfieService extends ApiService {

  constructor(restClient: AxiosInstance) {
    super(restClient, "/bureauSelfie");
  }

  public generateNewLink = async tradeId => await this.GET(BureauSelfieServiceEnum.generateNewLink + tradeId);
  public validateResendSelfie = async tradeId => await this.GET(BureauSelfieServiceEnum.validateResendSelfie + tradeId);
  public getSelfieImage = async tradeId => await this.GET(BureauSelfieServiceEnum.getSelfieImage + tradeId);
}


// WEBPACK FOOTER //
// ./src/services/api/BureauSelfie.service.ts